module.exports = __webpack_public_path__ + "static/img/resoce_grey.5eda302.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resoce_grey.png
// module id = DkLF
// module chunks = 21